import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-solid-down",
  "use": "icon-arrow-solid-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-solid-down\"><path d=\"M65.582671 288.791335l446.417329 446.41733 446.417329-446.41733z\" p-id=\"6094\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol